import React from "react";

import Image from "next/image";
import Link from "next/link";

import FigureImage from "public/images/enerflo-operating-system-for-residential-solar-software.png";

import Heading from "components/heading";

import HeroSection, { HeroSectionContainer } from "../../../hero-section";
import styles from "./index.module.css";

const title = "The Operating System For Residential Solar";

const MainHero = () => {
  return (
    <div className="relative overflow-hidden">
      <div className="absolute left-0 h-full w-full z-0 overflow-hidden">
        <div className="relative h-full w-full">
          <div className={styles.gradientBacking} />
          <div className={styles.overlayContainer}>
            <div className={styles.overlayInnerContainer}>
              <div className={styles.primaryOverlay} />
              <div className={styles.secondaryOverlay} />
            </div>
          </div>
        </div>
      </div>
      <HeroSectionContainer title="Consolidate Your Tech">
        <div className="flex flex-grow flex-col-reverse space-y-reverse space-y-4 items-center min-w-0 py-10 sm:py-14 lg:space-y-0 lg:space-x-4 text-white lg:flex-row z-10">
          <HeroSection.Content className="w-full md:text-center md:w-4/5 lg:text-left lg:w-1/2 lg:pr-0">
            <HeroSection.Tagline className="text-primary mb-4">{title}</HeroSection.Tagline>
            <HeroSection.Header className="lg:items-start">
              <Heading tag="h1" size="h2" className="text-primary">
                <span>Residential Solar Finally Has an</span>
                <br />
                <span className="text-white inline-block my-1">Operating System.</span>
              </Heading>
            </HeroSection.Header>

            <HeroSection.Description className="lg:my-4 lg:text-gray-100 leading-relaxed lg:text-lg lg:leading-relaxed lg:pr-14">
              Enerflo is the operating system (OS) for residential solar — connecting your solar CRM, design tools,
              solar financing, contracting, and project management into one infrastructure layer. From first knock to
              Permission to Operate (PTO). One system. One flow.
            </HeroSection.Description>
            <div className="-m-3 pt-6 lg:pt-2">
              <Link href="/demo">
                <a
                  className="btn text-sm lg:text-base btn-primary lg:btn-white m-3"
                  aria-label="Discover Enerflo"
                  id="hero-discover-enerflo"
                >
                  Book a Discovery Call
                </a>
              </Link>
            </div>
          </HeroSection.Content>

          <div className="flex-grow h-full w-11/12 2xs:w-4/5 xs:w-2/3 lg:w-1/2">
            <figure className="relative lg:w-full">
              <Image
                src={FigureImage}
                alt="Enerflo is THE solar platform for solar sales and operations."
                layout="responsive"
                quality={100}
                placeholder="blur"
                className="crispImage"
                priority
                loading="eager"
                sizes="(min-width: 768px) 50vw, 100vw"
              />
            </figure>
          </div>
        </div>
      </HeroSectionContainer>
    </div>
  );
};
export default MainHero;
